var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 33.3332V17.3332L21.3334 14.6665V33.3332",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 20H33.3334V33.3333H14.6667",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 21.3335V22.6668",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 25.3335V26.6668",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 24V25.3333",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 24V25.3333",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 28V29.3333",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 28V29.3333",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/Facilities.b65cdbfc0058ae309324243e54d1ff7c.svg";
export { ForwardRef as ReactComponent };